import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MainMenuService } from './main-menu.service';
import { AppConfigService } from '../app-config.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    standalone: false
})
export class MenuComponent implements OnInit {
    public logoImgUrl!: String;

    constructor(public menuService: MainMenuService, private config: AppConfigService) {
        // this.menuService.buildMenu([]);
    }

    ngOnInit() {
        this.logoImgUrl = `${this.config.getConfig().api}app/logo/${this.config.getConfig().cargoId}?ver=${Date.now()}`;
    }
}